var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadFile = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#DDE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.541 52.1612V58.9008C65.541 60.7389 63.9764 62.2707 62.0989 62.2707H38.4421C36.5646 62.2707 35 60.7389 35 58.9008V52.1612C35 51.671 35.4381 51.2422 35.9388 51.2422C36.4394 51.2422 36.8775 51.671 36.8775 52.1612V58.9008C36.8775 59.7586 37.5659 60.4326 38.4421 60.4326H62.0989C62.975 60.4326 63.6635 59.7586 63.6635 58.9008V52.1612C63.6635 51.671 64.1016 51.2422 64.6022 51.2422C65.1029 51.2422 65.541 51.6098 65.541 52.1612ZM52.0858 38.0692C51.5851 37.5791 50.8967 37.334 50.2709 37.334C49.645 37.334 48.9566 37.5791 48.4559 38.0692L44.075 42.3581C43.6995 42.7257 43.6995 43.2771 44.075 43.6447C44.4505 44.0124 45.0138 44.0124 45.3893 43.6447L49.3321 39.7848V54.7961C49.3321 55.2863 49.7702 55.7152 50.2709 55.7152C50.7715 55.7152 51.2096 55.2863 51.2096 54.7961V39.8464L55.1524 43.7064C55.5279 44.074 56.0912 44.074 56.4667 43.7064C56.8422 43.3387 56.8422 42.7873 56.4667 42.4197L52.0858 38.0692Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uploadFile.110aea4c81b7dc61ba150e82841891e1.svg";